import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export const Vtt = (props) => {
  return (
    <SvgIcon
      {...props}
      style={{ fill: props.fill || "transparent" }}
      viewBox={props.viewBox || "0 0 47 75"}
      width="47"
      height="75"
    >
      <path
        d="M-4 3.24046C-4 1.4508 -2.5492 0 -0.759537 0L31.6451 0L37.0459 5.40077L42.4466 10.8015V51.8474C42.4466 53.6371 40.9958 55.0879 39.2062 55.0879H-0.759538C-2.5492 55.0879 -4 53.6371 -4 51.8474L-4 3.24046Z"
        fill="#F7F7F7"
      />
      <g filter="url(#filter0_d_148_1555)">
        <path
          d="M42.4468 10.8017H33.8056C32.6125 10.8017 31.6453 9.83446 31.6453 8.64136V0.00012207L42.4468 10.8017Z"
          fill="white"
        />
      </g>
      <rect
        x="0.320557"
        y="38.28"
        width="37.8054"
        height="10.8015"
        rx="2.16031"
        fill="#1B2127"
      />
      <path
        d="M14.0626 41.4609L15.1331 44.826H15.1742L16.2469 41.4609H17.285L15.7581 45.89H14.5514L13.0224 41.4609H14.0626ZM17.6494 42.233V41.4609H21.2869V42.233H19.931V45.89H19.0053V42.233H17.6494ZM21.7173 42.233V41.4609H25.3549V42.233H23.9989V45.89H23.0733V42.233H21.7173Z"
        fill="white"
      />
      <path
        d="M3.95456 7.39542L5.22805 11.5662H5.27532L6.54881 7.39542H8.08923L6.16787 13.09H4.3355L2.41414 7.39542H3.95456ZM8.51604 8.5132V7.39542H13.3292V8.5132H11.6024V13.09H10.2455V8.5132H8.51604ZM13.8151 8.5132V7.39542H18.6282V8.5132H16.9015V13.09H15.5445V8.5132H13.8151Z"
        fill="black"
      />
      <rect
        x="1.59644"
        y="17.3477"
        width="36.3739"
        height="2.23839"
        fill="#E2E2E2"
      />
      <rect
        x="1.59644"
        y="22.384"
        width="36.3739"
        height="2.23839"
        fill="#E2E2E2"
      />
      <rect
        x="1.59644"
        y="27.4204"
        width="36.3739"
        height="2.23839"
        fill="#E2E2E2"
      />
      <rect
        x="1.59644"
        y="32.4568"
        width="36.3739"
        height="2.23839"
        fill="#E2E2E2"
      />
      <path
        d="M9.26474 66.2727L11.536 73.142H11.6255L13.8926 66.2727H15.6312L12.5545 75H10.6028L7.53036 66.2727H9.26474ZM16.3972 67.598V66.2727H23.3603V67.598H20.6628V75H19.0946V67.598H16.3972ZM24.3191 67.598V66.2727H31.2821V67.598H28.5847V75H27.0165V67.598H24.3191Z"
        fill="#484C56"
      />
      <defs>
        <filter
          id="filter0_d_148_1555"
          x="27.3246"
          y="0.00012207"
          width="19.4427"
          height="19.4427"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4.32062" />
          <feGaussianBlur stdDeviation="2.16031" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_148_1555"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_148_1555"
            result="shape"
          />
        </filter>
      </defs>
    </SvgIcon>
  );
};
